import React from "react";
import Score from "../../Score/Score";
import "./formCard.scss";
import { ReactComponent as LocationIcon } from "assets/icons/location.svg";
import PageButton from "components/PageButton/PageButton";

const FormCard = ({ product, dates, disabled, noSubmitButton }) => {
  let timeFormattedValue;
  const time = parseInt(dates.withdrawal_time);
  if (time === 0) {
    timeFormattedValue = `${time + 12} PM`;
  } else if (time < 13) {
    timeFormattedValue = `${time} AM`;
  } else if (time < 24) {
    timeFormattedValue = `${time - 12} PM`;
  } else {
    timeFormattedValue = null;
  }
  return (
    <div className="formCard">
      <section className="formCard__image__wrapper">
        <img
          className="formCard__image"
          src={product.images.find((e) => e.cover).url}
          alt={product.images.find((e) => e.cover).title}
        />
      </section>

      <div className="formCard__reservation">
        <section className="formCard__reservation__info">
          <h4 className="formCard__reservation__info__category">
            {product.category.title}
          </h4>
          <h2 className="formCard__reservation__info__title">
            {product.title}
          </h2>
          <Score onlyStars score={product.score} />
          <p className="formCard__reservation__info__location">
            <LocationIcon /> {product.location.city}
          </p>
        </section>

        <section className="formCard__reservation__dates">
          <div>
            <span>Check in</span>
            <span>{dates.check_in || "__/__/____"}</span>
          </div>
          <div>
            <span>Check out</span>
            <span>{dates.check_out || "__/__/____"}</span>
          </div>
          <div>
            <span>Horario de retiro</span>
            <span>{timeFormattedValue || "__ : __ hs"}</span>
          </div>
        </section>

        {noSubmitButton ? (
          ""
        ) : (
          <PageButton
            disabled={disabled}
            submit
            filled
            label="Confirmar reserva"
          />
        )}
      </div>
    </div>
  );
};

export default FormCard;
